import React, { useCallback, useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { paymentService } from '../../services/paymentService';
import './PaymentSuccess.css';

const PaymentSuccess = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('verifying');
  const [error, setError] = useState(null);

  const verifyPayment = useCallback(async (reference) => {
    try {
      console.log('Starting payment verification for reference:', reference);
      await paymentService.handlePaymentCompletion(
        reference,
        (data) => {
          console.log('Payment verification succeeded:', data);
          console.log('Setting status to success...');
          setStatus('success');
          console.log('New status:', 'success');
        },
        (error) => {
          console.log('Payment verification failed:', error);
          setStatus('error');
          setError(error);
        }
      );
    } catch (error) {
      setStatus('error');
      setError(error.message || 'Payment verification failed');
    }
  }, []);

  useEffect(() => {
    const reference = searchParams.get('reference');
    if (!reference) {
      setStatus('error');
      setError('No payment reference found');
      return;
    }

    verifyPayment(reference);
  }, [searchParams, verifyPayment]);

  return (
    <div className="payment-status-container">
      <div className="payment-status-card">
        {status === 'verifying' && (
          <>
            <div className="spinner"></div>
            <h2>Verifying Payment</h2>
            <p>Please wait while we verify your payment...</p>
          </>
        )}

        {status === 'success' && (
          <>
            <div className="success-icon">✓</div>
            <h2>Payment Successful!</h2>
            <p>Your internship application has been processed successfully.</p>
            <button 
              className="continue-button"
              onClick={(e) => {
                e.preventDefault();
                console.log('Navigating to homepage...');
                navigate('/');
              }}
            >
              Continue to Homepage
            </button>
          </>
        )}

        {status === 'error' && (
          <>
            <div className="error-icon">✗</div>
            <h2>Payment Verification Failed</h2>
            <p className="error-message">{error}</p>
            <button 
              className="retry-button"
              onClick={() => navigate('/request-for-letter')}
            >
              Return to Application
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default PaymentSuccess;
